export default "__VITE_ASSET__B5GuUXcD__"